import { library }            from '@fortawesome/fontawesome-svg-core';
import { faAccessibleIcon }   from '@fortawesome/free-brands-svg-icons/faAccessibleIcon';
import { faAngleDoubleLeft }  from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faAngleLeft }        from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight }       from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faBalanceScale }     from '@fortawesome/free-solid-svg-icons/faBalanceScale';
import { faBuilding }         from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faCheckSquare }      from '@fortawesome/free-solid-svg-icons/faCheckSquare';
import { faGlobe }            from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faGraduationCap }    from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons/faHandHoldingHeart';
import { faHandsHelping }     from '@fortawesome/free-solid-svg-icons/faHandsHelping';
import { faHome }             from '@fortawesome/free-solid-svg-icons/faHome';
import { faHotel }            from '@fortawesome/free-solid-svg-icons/faHotel';
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons/faLongArrowAltLeft';
import { faMedkit }           from '@fortawesome/free-solid-svg-icons/faMedkit';
import { faMoneyBillAlt }     from '@fortawesome/free-solid-svg-icons/faMoneyBillAlt';
import { faParachuteBox }     from '@fortawesome/free-solid-svg-icons/faParachuteBox';
import { faShoppingCart }     from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faSquare }           from '@fortawesome/free-solid-svg-icons/faSquare';
import { faTaxi }             from '@fortawesome/free-solid-svg-icons/faTaxi';
import { faUsers }            from '@fortawesome/free-solid-svg-icons/faUsers';
import { faWalking }          from '@fortawesome/free-solid-svg-icons/faWalking';
import { faWrench }           from '@fortawesome/free-solid-svg-icons/faWrench';

library.add(
  faAccessibleIcon,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faBalanceScale,
  faBuilding,
  faCheckSquare,
  faGlobe,
  faGraduationCap,
  faHandHoldingHeart,
  faHandsHelping,
  faHome,
  faHotel,
  faLongArrowAltLeft,
  faMedkit,
  faMoneyBillAlt,
  faParachuteBox,
  faShoppingCart,
  faSquare,
  faTaxi,
  faUsers,
  faWalking,
  faWrench,
);






// WEBPACK FOOTER //
// ./src/config/fontawesome.js